module.exports = __webpack_public_path__ + "img/baobiao.6ba27c24.svg";